/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClaimWidgetRequest
 */
export interface CreateClaimWidgetRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimWidgetRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClaimWidgetRequest
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateClaimWidgetRequest
     */
    allowedOrigins: Array<string>;
}

/**
 * Check if a given object implements the CreateClaimWidgetRequest interface.
 */
export function instanceOfCreateClaimWidgetRequest(value: object): value is CreateClaimWidgetRequest {
    if (!('allowedOrigins' in value) || value['allowedOrigins'] === undefined) return false;
    return true;
}

export function CreateClaimWidgetRequestFromJSON(json: any): CreateClaimWidgetRequest {
    return CreateClaimWidgetRequestFromJSONTyped(json, false);
}

export function CreateClaimWidgetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimWidgetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'allowedOrigins': json['allowedOrigins'],
    };
}

export function CreateClaimWidgetRequestToJSON(json: any): CreateClaimWidgetRequest {
    return CreateClaimWidgetRequestToJSONTyped(json, false);
}

export function CreateClaimWidgetRequestToJSONTyped(value?: CreateClaimWidgetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'isActive': value['isActive'],
        'allowedOrigins': value['allowedOrigins'],
    };
}

